import { useMutation,useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { container } from "tsyringe";
import { useCallback } from "react";
import { ProjectsService } from "src/apis/services/projects/projectsService";
export const useDeleteProjects = () => {
    const projectsService = container.resolve(ProjectsService);
    

    const queryClient = useQueryClient();

    const toggleDeleteProjects = useCallback(
        (targetProjectsId) => {

                queryClient.removeQueries([Api.Projects.getProjects]);
            
        },
        [],
    )

    return useMutation({
        mutationFn: (projectId: number) => {
            return projectsService.deleteProjects(projectId);
        },
        onSuccess: (data, targetId, context) => {
            toggleDeleteProjects(targetId);
        }
    })
}